<template>
  <div class="link" v-bind="$attrs">
    <img class="link-png" :src="require(`@/assets/img/nav-link/${filename}.png`)" :alt="text">
    <img class="ring ring-1" src="@/assets/img/icon/ring-1.png" alt="科技框1">
    <img class="ring ring-2" src="@/assets/img/icon/ring-2.png" alt="科技框2">
  </div>
</template>

<script>
export default {
  name: 'NavLink',
  props: {
    filename: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.link {
  position: absolute;
  z-index: 10;
  width: 1.6rem;
  height: 1.6rem;
  transition: all 0.3s ease-out;
  cursor: pointer;
  &:hover {
    transform: scale(1.1);
  }
  & > .link-png {
    position: absolute;
    width: 70%;
    height: 70%;
    margin: 15%;
    border-radius: 50%;
  }
  & > .ring {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  & > .ring-1 {
    animation: spin-left 4.5s linear infinite;
  }
  & > .ring-2 {
    animation: spin-right 4.5s linear infinite;
  }
}
</style>
